var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationOperation = function SvgGeneralInformationOperation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.93 20.46-6.545-6.545.53-.53 6.545 6.545zM2.1 9.223h3.749v-.75H2.1zM11.849 9.223h3.748v-.75h-3.748zM8.474 15.596h.75v-3.748h-.75zM8.474 5.848h.75V2.1h-.75zM12.498 13.028l-1.53-1.529.53-.53 1.53 1.53zM6.197 6.727l-1.53-1.529.531-.53 1.53 1.53zM11.5 6.727l-.531-.53 1.53-1.53.53.531zM5.198 13.028l-.53-.53 1.529-1.53.53.531z"
  }))));
};
export default SvgGeneralInformationOperation;